import { render, staticRenderFns } from "./CouponIndex.vue?vue&type=template&id=50e542cf&scoped=true&lang=pug&"
import script from "./CouponIndex.vue?vue&type=script&lang=js&"
export * from "./CouponIndex.vue?vue&type=script&lang=js&"
import style0 from "./CouponIndex.vue?vue&type=style&index=0&id=50e542cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e542cf",
  null
  
)

export default component.exports